import React from 'react';
import Service from '../Components/Service';

const Services = () => {
    return (
        <div>
            <Service></Service>
        </div>
    );
};

export default Services;